import useURLSearchParam from '@/hook/useURLSearchParams'
import authClient from '@/utils/auth'
import { copyToClipboard } from '@/utils/clipboard'
import { storeAccessToken, storeRefreshToken } from '@/utils/tokenUtils'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Space, Card, Form, Input, Button, Toast, TextArea } from 'antd-mobile'
import { useState } from 'react'
function handleWeiLogin(state: number) {
  const appId = 'wx42e4274305b61fb9'
  // #region get redirect_uri_without_code
  const currentURL = new URL(window.location.href)
  const currentURLSearchParams = new URLSearchParams(window.location.search)
  currentURLSearchParams.delete('code')
  currentURL.search = currentURLSearchParams.toString()
  const redirectUriWithoutCode = currentURL.toString()
  // #endregion
  const baseURL = 'https://open.weixin.qq.com/connect/oauth2/authorize'
  const searchParams = new URLSearchParams({
    appid: appId,
    redirect_uri: redirectUriWithoutCode,
    response_type: 'code',
    scope: 'snsapi_base',
    state: state.toString(),
  })
  const hash = '#wechat_redirect'

  const fullLoginUrl = new URL(baseURL)
  fullLoginUrl.search = searchParams.toString()
  fullLoginUrl.hash = hash

  window.location.replace(fullLoginUrl)
}
function RouteComponent() {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  async function handleLogin(values: { username: string; password: string }) {
    if (values.username && values.password) {
      const { access_token, refresh_token } = (await authClient.post(
        '/user/test-login',
        values,
      )) as {
        access_token: string
        refresh_token: string
      }
      storeAccessToken(access_token)
      storeRefreshToken(refresh_token)
      Toast.show({
        content: '登录成功',
      })
      navigate({ to: '/', replace: true })
      return
    }
    Toast.show({
      content: '登录信息不完整',
    })
  }
  const [state, setState] = useState(123)
  const [code, setCode] = useURLSearchParam('code', 'initial')
  return (
    <Space direction="vertical" style={{ width: '100%' }} align="center">
      <Card>
        <Form form={form} onFinish={handleLogin}>
          <Form.Item
            name="username"
            initialValue={'o9S49vs_BPT14V9UF3G8x3EGvhew'}
          >
            <Input placeholder="请输入用户名" />
          </Form.Item>
          <Form.Item name="password">
            <Input placeholder="请输入密码" />
          </Form.Item>
          <Form.Item>
            <Button type="submit">登录</Button>
            <Button
              onClick={() => {
                navigate({ to: '/test/token-login' })
              }}
            >
              token登录
            </Button>
            <Button
              onClick={() => {
                navigate({ to: '/login' })
              }}
            >
              微信登录
            </Button>
          </Form.Item>
          <Form.Item label="code">
            <TextArea value={code ?? ''} onChange={(val) => setCode(val)} />
          </Form.Item>
          <Button
            onClick={() => {
              handleWeiLogin(state)
            }}
          >
            refresh code
          </Button>
          <Button
            onClick={() => {
              copyToClipboard(code ?? '')
                .then(() => {
                  Toast.show('success')
                })
                .catch((e) => {
                  console.error(e)
                  Toast.show('error')
                })
            }}
          >
            copy code
          </Button>
          <Form.Item label="state">
            <TextArea value={state.toString() ?? ''} />
            <Button
              onClick={() => {
                setState((prev) => prev + 1)
              }}
            >
              +1
            </Button>
          </Form.Item>
          <Form.Item label="uri">
            <TextArea value={window.location.href ?? ''} />
          </Form.Item>
        </Form>
      </Card>
    </Space>
  )
}
export const Route = createFileRoute('/test/manual-login')({
  component: RouteComponent,
})
